import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import Swal from "sweetalert2";
export default function NewCheckoutPage() {

  const { orderId } = useParams();
  const navigate = useNavigate();
const [couponCode, setCouponCode] = useState("");
  const [order, setOrder] = useState(null);
const [couponApplied, setCouponApplied] = useState(false);
 const [previewImage, setPreviewImage] = useState(null);
const [loading, setLoading] = useState(true);
  // Load order
  useEffect(() => {

    const loadOrder = async () => {
      try {

        const res = await axiosInstance.get(`/orders/${orderId}/`);
console.log(res.data);
console.log(res.data.prescriptions);
        setOrder(res.data);

// ✅ check if already applied
if (parseFloat(res.data.discount_amount) > 0) {
  setCouponApplied(true);
}


      } catch (err) {

  console.error("Order Load Error:", err.response?.data);

  if (err.response?.status === 401) {
    navigate("/login");
  } else {
    alert("Order not found ❌");
  }
}
 finally {

        setLoading(false);

      }
    };

    loadOrder();

  }, [orderId]);



const applyCoupon = async () => {

  if (!couponCode.trim()) {
    alert("Enter coupon");
    return;
  }

  try {

    const res = await axiosInstance.post(
      "/orders/apply-coupon/",
      {
        order_id: order.id,
        coupon_code: couponCode.trim().toUpperCase()
      }
    );

    setOrder(prev => ({
      ...prev,
      discount_amount: res.data.discount,
      payable_amount: res.data.payable_amount
    }));

    setCouponApplied(true);
alert("Coupon applied ✅");


  } catch (err) {
    alert(err.response?.data?.error || "Invalid coupon ❌");
  }
};


  if (loading) return <p>Loading...</p>;

  if (!order) return <p>Order not found</p>;

console.log("METHOD =", order.payment_method);
  return (
    <div style={container}>

      <h2>🛒 Checkout</h2>

      <div style={card}>

        <h4>Order #{order.id}</h4>

        <p><b>Name:</b> {order.user}</p>
        <p><b>Phone:</b> {order.phone}</p>

        <hr />

        <h4>Items</h4>

        {order.items && order.items.map((item, i) => (

          <div key={i} style={row}>
            <span>{item.name}</span>
            <span>× {item.qty}</span>
          </div>
        ))}
	
{order?.prescriptions?.length > 0 && (
  <div style={{ marginTop: "20px" }}>
    <h4>📄 Uploaded Bill / Receipt</h4>

    <p style={{ fontSize: "13px", color: "#888", marginBottom: "10px" }}>
      💡 Tip: Click image to view full size or download for better clarity
    </p>

    {order.prescriptions.map((p) => {
      if (!p?.url) return null;   // 👈 BEST PRACTICE

      return (
        <div
          key={p.id}
          style={{
            position: "relative",
            display: "inline-block",
            marginBottom: "15px",
          }}
        >
          {/* IMAGE */}
          <img
            src={p.url}
            alt="bill"
            onClick={() => setPreviewImage(p.url)}
            style={{
              width: "100%",
              maxWidth: "280px",
              borderRadius: "10px",
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            }}
          />

          {/* DOWNLOAD BUTTON */}
          <a
            href={p.url}
            target="_blank"
            rel="noreferrer"
            style={{
              position: "absolute",
              bottom: "8px",
              right: "8px",
              background: "rgba(0,0,0,0.7)",
              color: "#fff",
              padding: "5px 10px",
              borderRadius: "6px",
              fontSize: "12px",
              textDecoration: "none",
            }}
          >
            ⬇ Download
          </a>
        </div>
      );
    })}
  </div>
)}
{previewImage && (
  <div
    onClick={() => setPreviewImage(null)}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.8)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    }}
  >
    <img
      src={previewImage}
      onClick={(e) => e.stopPropagation()}
      alt="preview"
      style={{
        maxWidth: "90%",
        maxHeight: "90%",
        borderRadius: "10px",
      }}
    />
  </div>
)}





 

<h4>Apply Coupon</h4>

<input
  value={couponCode}
  onChange={(e) => setCouponCode(e.target.value)}
  placeholder="Enter Coupon"
  disabled={couponApplied}
  style={{
    width: "100%",
    padding: 8,
    background: couponApplied ? "#f3f4f6" : "white"
  }}
/>

<button
  onClick={applyCoupon}
  disabled={couponApplied}
  style={{
    marginTop: 8,
    padding: 10,
    width: "100%",
    background: couponApplied ? "#9ca3af" : "#2563eb",
    color: "white",
    border: "none",
    borderRadius: 6,
    cursor: couponApplied ? "not-allowed" : "pointer"
  }}
>
  {couponApplied ? "Coupon Applied ✅" : "Apply Coupon"}
</button>
{couponApplied && (
  <p style={{
    color: "green",
    marginTop: 8,
    fontWeight: "bold"
  }}>
    🎉 Coupon already applied to this order
  </p>
)}


	{/* Pricing Section */}

{order.is_manual ? (

  <>
    <p>📄 Bill Amount: ₹{order.bill_amount}</p>
    <p>🚚 Delivery: ₹{order.delivery_charge}</p>
    <p>🏷 Discount: -₹{order.discount_amount}</p>
  </>

) : (

  <>
    <p>🛒 Cart Total: ₹{order.cart_total}</p>
    <p>🚚 Delivery: ₹{order.delivery_charge}</p>
    <p>🏷 Discount: -₹{order.discount_amount}</p>
  </>

)}

<hr />

<h3>Total Payable: ₹{order.payable_amount}</h3>
{/* Store Pickup Message */}
{order.status === "approved_store_pickup" && (

  <p style={{ color: "green", fontWeight: "bold" }}>
    🏬 You can pay online to get the benefit of coupoun or pay at store counter
  </p>

)}


{/* Pay Button ALWAYS AVAILABLE */}
<button
  style={payBtn}
  onClick={async () => {

    // ✅ COD ORDER
    if (order.payment_method?.toLowerCase() === "cod") {

  try {

    await axiosInstance.post(
      `/orders/${order.id}/confirm-cod/`
    );

    await Swal.fire({
      icon: "success",
      title: "Order Confirmed ✅",
      text: "Your COD order has been confirmed successfully.",
      confirmButtonColor: "#16a34a"
    });

    navigate("/orders");

  } catch (err) {

    await Swal.fire({
    icon: "error",
    title: "Failed",
    text: "Failed to confirm COD order",
    confirmButtonColor: "#dc2626"
  });
  }

  return;
}

    // ✅ ONLINE ORDER
    navigate(`/payment/${order.id}`);
  }}
>
  {order.payment_method?.toLowerCase() === "cod"
    ? "Proceed Order 🚚"
    : "Pay Now 💳"}
</button>





      </div>

    </div>
  );
}


/* Styles */

const container = {
  maxWidth: 500,
  margin: "auto",
  padding: 20
};

const card = {
  background: "#fff",
  padding: 20,
  borderRadius: 10,
  boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
};

const row = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: 6
};

const payBtn = {
  width: "100%",
  padding: 12,
  background: "#16a34a",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
  fontSize: 16
};
